import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Link} from 'react-router-dom'
import Button from 'material-ui/Button'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Tooltip from 'material-ui/Tooltip'
import {withStyles} from 'material-ui/styles'
import {
  Badge,
  Button as SpectrumButton,
  Provider,
  Text as SpectrumText
} from '@adobe/react-spectrum'
import {customSpectrumTheme} from '../../themes/spectrum-theme'
import {Star} from 'lucide-react'
import styles from './styles'

import withRole from '../hoc/role'
import SubscriptionUpgradeDialog from './subscription-upgrade-dialog'
import SubscriptionStatusDialog from './subscription-status-dialog'
import UnifiedSubscriptionWizard from './unified-subscription-wizard'
import {setNavigationStatus, userGet} from '../../redux/actions'
import {ROLES_IDEAL} from '../../common/constants'

import Auth from '../../auth'
import NotificationsModal from "../notifications";

const auth = new Auth()

{ /* const SupportButtonWithRole = withRole((props) => {
  return (
    <Tooltip title="Support">
      <Button aria-label="Support" className={props.classes.button} color="accent" fab mini component={Link} to="/support">
        <Icon>headset_mic</Icon>
      </Button>
    </Tooltip>
  )
}, ROLES_IDEAL) */
}

const SettingsButtonWithRole = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_settings")}
             disableTriggerFocus={true}>
      <Button aria-label="Settings" className={props.classes.button}
              color="accent" fab mini component={Link} to="/settings">
        <Icon>settings</Icon>
      </Button>
    </Tooltip>
  )
}, ROLES_IDEAL)

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isNotificationsOpen: false,
      subscriptionModalOpen: false,
      wizardModalOpen: false,
      checkoutModalOpen: false,
      unifiedWizardOpen: false  // New unified subscription wizard
    }
  }

  toggleMenu() {
    this.props.set(!this.props.status)
  }

  toggleSubscriptionModal = () => {
    this.setState({subscriptionModalOpen: !this.state.subscriptionModalOpen})
  }

  toggleWizardModal = () => {
    this.setState({wizardModalOpen: !this.state.wizardModalOpen})
  }

  toggleCheckoutModal = () => {
    this.setState({checkoutModalOpen: !this.state.checkoutModalOpen})
  }

  // New unified wizard handler
  toggleUnifiedWizard = () => {
    this.setState({unifiedWizardOpen: !this.state.unifiedWizardOpen})
  }

  handleWizardClose = () => {
    // Close wizard without opening checkout
    this.setState({wizardModalOpen: false})
  }

  handleWizardProceedToCheckout = () => {
    // Called when wizard completes and user clicks Proceed to Checkout
    this.setState({wizardModalOpen: false})
    setTimeout(() => {
      this.setState({checkoutModalOpen: true})
    }, 300)
  }


  handleLogout() {
    auth.logout()
  }

  setNotificationsModalOpen(isOpen) {
    this.setState({ isNotificationsOpen: isOpen });
  }

  render() {
    const {
      classes,
      translate,
      profile,
      set,
      user,
      loggedInUserNameInitials,
      impersonating,
      currentSubscription,
      softwareUpdate,
      archiveCounts,
      activeFeatures
    } = this.props;
    const canAccessSubscriptionSignup = activeFeatures?.some(feature => feature.featureName === 'cloud_subscription_signup')
    const hasLrpFreeFeatures = activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')
    const hasPlusSubscription = currentSubscription && currentSubscription.tier && currentSubscription.tier !== 'basic'
    const showSubscriptionButton = currentSubscription && (canAccessSubscriptionSignup || hasPlusSubscription || currentSubscription.checkoutPending)

    let margintop = "0px";

    if (impersonating && softwareUpdate) {
      margintop = "120px";
    } else if (impersonating || softwareUpdate) {
      margintop = "60px";
    }

    const isArchive = archiveCounts && (archiveCounts.jobcount || archiveCounts.reportcount);

    return (
        <AppBar position="fixed" className={classes.navBar} style={{marginTop: margintop}}>
          <div className={classes.centred}>
            <Toolbar>
              <IconButton className={classes.burger} onClick={() => this.toggleMenu()} color="inherit">
                <Icon>menu</Icon>
              </IconButton>

              <div className={classes.headerLogo}>
                <Link to={hasLrpFreeFeatures ? '/home' : '/jobs'} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                  <img alt="Home" className={[classes.image]} src={'/images/header_logo.svg'} />
                </Link>
              </div>

              {showSubscriptionButton && (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <SpectrumButton
                    variant="accent"
                    onPress={this.toggleSubscriptionModal}
                  >
                    <Star size={18}/>
                    <SpectrumText>
                      {currentSubscription.tier === 'basic' ? 'Upgrade to Plus' : 'Plus Features'}
                    </SpectrumText>
                  </SpectrumButton>
                  {currentSubscription.status === 'CanceledScheduled' && (
                    <Badge variant={"yellow"}>
                      {(() => {
                        const endDate = new Date(currentSubscription.currentPeriodEnd)
                        const today = new Date()
                        const daysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24))
                        return Math.max(1, daysLeft)
                      })()} days left
                    </Badge>
                  )}
                </div>
                )}

            {isArchive &&
              <Tooltip title={translate("notifications")} disableTriggerFocus={true}>
                <Button aria-label="Notifications" className={classes.button} fab mini onClick={() => this.setNotificationsModalOpen(true)}>
                  <Icon>error</Icon>
                </Button>
              </Tooltip>
            }

            <Tooltip title={translate("tooltip_my_account")} disableTriggerFocus={true}>
              <Button aria-label="My Account" className={classes.button} fab mini component={Link} to="/profile">
                {
                  (user && user.hasOwnProperty('success')) ?
                    <Icon>person</Icon>
                    :

                    <span className={classes.loggedInInitials}>{loggedInUserNameInitials}</span>

                }
              </Button>
            </Tooltip>

              {(profile && profile.roles && profile.roles === "idealadmin") ? (
                <SettingsButtonWithRole classes={classes} translate={translate} />
              ) : null}

              <Tooltip title={translate("tooltip_log_out")}>
                <Button
                  aria-label="Log Out"
                  className={classes.button}
                  fab
                  mini
                  onClick={this.handleLogout.bind(this)}
                >
                  <Icon>power_settings_new</Icon>
                </Button>
              </Tooltip>
            </Toolbar>
          </div>

          {hasPlusSubscription && (currentSubscription?.status === 'Active' || currentSubscription?.status === 'CanceledScheduled' || currentSubscription?.status === 'PastDue') ? (
            <SubscriptionStatusDialog
              open={this.state.subscriptionModalOpen}
              onClose={this.toggleSubscriptionModal}
              subscription={currentSubscription}
              deviceCount={(currentSubscription && currentSubscription.devices) || 1}
              stripeCustomerPortalUrl={this.props.stripeCustomerPortalUrl}
              readOnly={impersonating}
            />
          ) : canAccessSubscriptionSignup ? (
            <SubscriptionUpgradeDialog
              open={this.state.subscriptionModalOpen}
              onClose={this.toggleSubscriptionModal}
              deviceCount={(currentSubscription && currentSubscription.devices) || 1}
              onOpenWizard={impersonating ? undefined : this.toggleUnifiedWizard}
              readOnly={impersonating}
            />
          ) : null}

          {/* New Unified Subscription Wizard - Production-ready 4-step wizard */}
          {canAccessSubscriptionSignup && (
            <UnifiedSubscriptionWizard
              open={this.state.unifiedWizardOpen}
              onClose={() => this.setState({ unifiedWizardOpen: false })}
              onSuccess={() => {
                this.setState({ unifiedWizardOpen: false })
                // Optionally refresh app settings to get updated subscription status
                window.location.reload()
              }}
            />
          )}
          <NotificationsModal translate={translate} isOpen={this.state.isNotificationsOpen} onClose={() => this.setNotificationsModalOpen(false)} />
        </AppBar>
    )
  }
}

const mapStateToProps = (state) => ({
  status: state.navigationReducer.status,
  profile: state.profileReducer.profile,
  user: state.userReducer.user,
  loggedInUserNameInitials: state.userReducer.loggedInUserNameInitials,
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  currentSubscription: state.appSettingReducer.currentSubscription,
  stripeCustomerPortalUrl: state.appSettingReducer.stripeCustomerPortalUrl,
  activeFeatures: state.appSettingReducer.activeFeatures,
  archiveCounts: state.archiveReducer.archiveCounts,
  ...state
})

const mapDispatchToProps = (dispatch, props) => ({
  userGet: (id) => {
    dispatch(userGet(id))
  },
  set: (status) => {
    dispatch(setNavigationStatus(status))
  }
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Header);
